import { render, staticRenderFns } from "./DetailAdvertisingPage.vue?vue&type=template&id=12705d8b&"
import script from "./DetailAdvertisingPage.vue?vue&type=script&lang=js&"
export * from "./DetailAdvertisingPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailAdvertisingPage.vue?vue&type=style&index=0&id=12705d8b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports